export default "__VITE_ASSET__64651dce__"